export default __webpack_public_path__ + "static/media/rejectIcon.638485c9.svg";